/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FleetYards.net API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/vue-query';
import type {
  DataTag,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseMutationReturnType,
  UseQueryOptions,
  UseQueryReturnType
} from '@tanstack/vue-query';

import {
  toValue,
  unref
} from 'vue';
import type {
  MaybeRefOrGetter
} from 'vue';

import type {
  Hangar,
  HangarExportParams,
  HangarImportResult,
  HangarItemsList,
  HangarLinkExportParams,
  HangarParams,
  HangarSyncStatus,
  HangarSyncSubmitResult,
  ImportInput,
  SchemaValidationErrorResponse,
  StandardError,
  SyncRsiHangarInput,
  ValidationError,
  VehicleExportsList
} from '../../models';

import { axiosClient } from '../../../axiosClient.ts';
import type { ErrorType } from '../../../axiosClient.ts';




/**
 * @summary Clear your personal Hangar
 */
export const destroyHangar = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/hangar`, method: 'DELETE', signal
    },
      );
    }




export const getDestroyHangarMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext> => {

const mutationKey = ['destroyHangar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof destroyHangar>>, void> = () => {


          return  destroyHangar()
        }






  return  { mutationFn, ...mutationOptions }}

    export type DestroyHangarMutationResult = NonNullable<Awaited<ReturnType<typeof destroyHangar>>>

    export type DestroyHangarMutationError = ErrorType<StandardError>


    /**
 * @summary Clear your personal Hangar
 */
export const useDestroyHangar = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof destroyHangar>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof destroyHangar>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getDestroyHangarMutationOptions(options), queryClient);
    }
    /**
 * @summary Your personal Hangar
 */
export const hangar = (
    params?: MaybeRefOrGetter<HangarParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<Hangar>(
      {url: `/hangar`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarQueryKey = (params?: MaybeRefOrGetter<HangarParams>,) => {
    return [
    'hangar', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarQueryOptions = <TData = Awaited<ReturnType<typeof hangar>>, TError = ErrorType<StandardError>>(params?: MaybeRefOrGetter<HangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangar>>> = ({ signal }) => hangar(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>
}

export type HangarQueryResult = NonNullable<Awaited<ReturnType<typeof hangar>>>
export type HangarQueryError = ErrorType<StandardError>


/**
 * @summary Your personal Hangar
 */

export function useHangar<TData = Awaited<ReturnType<typeof hangar>>, TError = ErrorType<StandardError>>(
 params?: MaybeRefOrGetter<HangarParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangar>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export your personal Hangar
 */
export const hangarExport = (
    params?: MaybeRefOrGetter<HangarExportParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<VehicleExportsList>(
      {url: `/hangar/export`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarExportQueryKey = (params?: MaybeRefOrGetter<HangarExportParams>,) => {
    return [
    'hangar','export', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarExportQueryOptions = <TData = Awaited<ReturnType<typeof hangarExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarExport>>> = ({ signal }) => hangarExport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>
}

export type HangarExportQueryResult = NonNullable<Awaited<ReturnType<typeof hangarExport>>>
export type HangarExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Export your personal Hangar
 */

export function useHangarExport<TData = Awaited<ReturnType<typeof hangarExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Export your personal Hangar for hangar.link
 */
export const hangarLinkExport = (
    params?: MaybeRefOrGetter<HangarLinkExportParams>,
 signal?: AbortSignal
) => {
      params = toValue(params);

      return axiosClient<VehicleExportsList>(
      {url: `/hangar/export/hangar-link`, method: 'GET',
        params, signal
    },
      );
    }




export const getHangarLinkExportQueryKey = (params?: MaybeRefOrGetter<HangarLinkExportParams>,) => {
    return [
    'hangar','export','hangar-link', ...(params ? [params] : [])
    ] as const;
    }


export const getHangarLinkExportQueryOptions = <TData = Awaited<ReturnType<typeof hangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(params?: MaybeRefOrGetter<HangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarLinkExportQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarLinkExport>>> = ({ signal }) => hangarLinkExport(params, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>
}

export type HangarLinkExportQueryResult = NonNullable<Awaited<ReturnType<typeof hangarLinkExport>>>
export type HangarLinkExportQueryError = ErrorType<SchemaValidationErrorResponse | StandardError>


/**
 * @summary Export your personal Hangar for hangar.link
 */

export function useHangarLinkExport<TData = Awaited<ReturnType<typeof hangarLinkExport>>, TError = ErrorType<SchemaValidationErrorResponse | StandardError>>(
 params?: MaybeRefOrGetter<HangarLinkExportParams>, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarLinkExport>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarLinkExportQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Import to your personal Hangar
 */
export const hangarImport = (
    importInput: MaybeRefOrGetter<ImportInput>,
 signal?: AbortSignal
) => {
      importInput = toValue(importInput);

      return axiosClient<HangarImportResult>(
      {url: `/hangar/import`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: importInput, signal
    },
      );
    }




export const getHangarImportMutationOptions = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext> => {

const mutationKey = ['hangarImport'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof hangarImport>>, HangarImportMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  hangarImport(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type HangarImportMutationResult = NonNullable<Awaited<ReturnType<typeof hangarImport>>>
    export type HangarImportMutationBody = ImportInput
    export type HangarImportMutationError = ErrorType<ValidationError | StandardError>
    export type HangarImportMutationVariables = {data: ImportInput}

    /**
 * @summary Import to your personal Hangar
 */
export const useHangarImport = <TError = ErrorType<ValidationError | StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof hangarImport>>, TError,HangarImportMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof hangarImport>>,
        TError,
        HangarImportMutationVariables,
        TContext
      > => {
      return useMutation(getHangarImportMutationOptions(options), queryClient);
    }
    /**
 * @summary Your personal Hangar items
 */
export const hangarItems = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarItemsList>(
      {url: `/hangar/items`, method: 'GET', signal
    },
      );
    }




export const getHangarItemsQueryKey = () => {
    return [
    'hangar','items'
    ] as const;
    }


export const getHangarItemsQueryOptions = <TData = Awaited<ReturnType<typeof hangarItems>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getHangarItemsQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof hangarItems>>> = ({ signal }) => hangarItems(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>
}

export type HangarItemsQueryResult = NonNullable<Awaited<ReturnType<typeof hangarItems>>>
export type HangarItemsQueryError = ErrorType<StandardError>


/**
 * @summary Your personal Hangar items
 */

export function useHangarItems<TData = Awaited<ReturnType<typeof hangarItems>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof hangarItems>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getHangarItemsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






/**
 * @summary Move all Ingame Ships from your Hangar to your Wishlist
 */
export const moveAllIngameToWishlist = (

 signal?: AbortSignal
) => {


      return axiosClient<void>(
      {url: `/hangar/move-all-ingame-to-wishlist`, method: 'PUT', signal
    },
      );
    }




export const getMoveAllIngameToWishlistMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext> => {

const mutationKey = ['moveAllIngameToWishlist'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, void> = () => {


          return  moveAllIngameToWishlist()
        }






  return  { mutationFn, ...mutationOptions }}

    export type MoveAllIngameToWishlistMutationResult = NonNullable<Awaited<ReturnType<typeof moveAllIngameToWishlist>>>

    export type MoveAllIngameToWishlistMutationError = ErrorType<StandardError>


    /**
 * @summary Move all Ingame Ships from your Hangar to your Wishlist
 */
export const useMoveAllIngameToWishlist = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof moveAllIngameToWishlist>>, TError,void, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof moveAllIngameToWishlist>>,
        TError,
        void,
        TContext
      > => {
      return useMutation(getMoveAllIngameToWishlistMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync RSI Hangar
 */
export const syncRsiHangar = (
    syncRsiHangarInput: MaybeRefOrGetter<SyncRsiHangarInput>,
 signal?: AbortSignal
) => {
      syncRsiHangarInput = toValue(syncRsiHangarInput);

      return axiosClient<HangarSyncSubmitResult>(
      {url: `/hangar/sync-rsi-hangar`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: syncRsiHangarInput, signal
    },
      );
    }




export const getSyncRsiHangarMutationOptions = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext> => {

const mutationKey = ['syncRsiHangar'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof syncRsiHangar>>, SyncRsiHangarMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  syncRsiHangar(data,)
        }






  return  { mutationFn, ...mutationOptions }}

    export type SyncRsiHangarMutationResult = NonNullable<Awaited<ReturnType<typeof syncRsiHangar>>>
    export type SyncRsiHangarMutationBody = SyncRsiHangarInput
    export type SyncRsiHangarMutationError = ErrorType<StandardError>
    export type SyncRsiHangarMutationVariables = {data: SyncRsiHangarInput}

    /**
 * @summary Sync RSI Hangar
 */
export const useSyncRsiHangar = <TError = ErrorType<StandardError>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof syncRsiHangar>>, TError,SyncRsiHangarMutationVariables, TContext>, }
 , queryClient?: QueryClient): UseMutationReturnType<
        Awaited<ReturnType<typeof syncRsiHangar>>,
        TError,
        SyncRsiHangarMutationVariables,
        TContext
      > => {
      return useMutation(getSyncRsiHangarMutationOptions(options), queryClient);
    }
    /**
 * @summary Sync RSI Hangar Status
 */
export const syncRsiHangarStatus = (

 signal?: AbortSignal
) => {


      return axiosClient<HangarSyncStatus>(
      {url: `/hangar/sync-rsi-hangar/status`, method: 'GET', signal
    },
      );
    }




export const getSyncRsiHangarStatusQueryKey = () => {
    return [
    'hangar','sync-rsi-hangar','status'
    ] as const;
    }


export const getSyncRsiHangarStatusQueryOptions = <TData = Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError = ErrorType<StandardError>>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  getSyncRsiHangarStatusQueryKey();



    const queryFn: QueryFunction<Awaited<ReturnType<typeof syncRsiHangarStatus>>> = ({ signal }) => syncRsiHangarStatus(signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>
}

export type SyncRsiHangarStatusQueryResult = NonNullable<Awaited<ReturnType<typeof syncRsiHangarStatus>>>
export type SyncRsiHangarStatusQueryError = ErrorType<StandardError>


/**
 * @summary Sync RSI Hangar Status
 */

export function useSyncRsiHangarStatus<TData = Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError = ErrorType<StandardError>>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof syncRsiHangarStatus>>, TError, TData>>, }
 , queryClient?: QueryClient
 ): UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getSyncRsiHangarStatusQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as UseQueryReturnType<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = unref(queryOptions).queryKey as DataTag<QueryKey, TData, TError>;

  return query;
}






